import React from 'react';
import { Heading } from '@legalshield/adonis-ux-framework';

const commitmentList = [
  'I acknowledge that I have been informed regarding the Provider Firm’s commitment to LegalShield and the members of LegalShield.',
  'I will treat all LegalShield members with the same respect and courtesy I extend to my clients, along with meeting all ethical rules of professional responsibility set forth by the State Bar Association in the state where I practice.',
  'I will do my utmost to ensure that all calls that I receive from LegalShield members will be returned in 4 to 8 business hours by me or the appropriate member of my staff.',
  'I will contact the Provider Firm if for any reason I am not able to return a call from a LegalShield member or if I am not able to reach a LegalShield member after three (3) attempts.',
  'I will only speak positively to LegalShield members regarding the LegalShield and its products and procedures. I will submit any questions, critiques, or criticisms that I may have directly to appropriate personnel at the Provider Firm or corporate offices of the company.',
  'I will inform the Provider Firm in the event I am not able to accept a referral. I understand it is the Provider Firm’s responsibility to arrange a referral, and therefore, I will not attempt to refer the member to another attorney if I am unable to assist.',
  'I will inform the Provider Firm if I decide to withdraw as the attorney in any matter I have accepted representation for a LegalShield member.',
  'I will execute a separate Attorney-Client contract in all matters in which I accept representation for a LegalShield member. The contract will clearly state my hourly rate or flat rate, the corresponding discount provide to the LegalShield member, and the amount of the required retainer. Each billing invoice will show the total before LegalShield discount and total after discount.',
  'I will provide a monthly billing statement to each LegalShield member for whom I have accepted representation.',
  'I will contact the Provider Firm to seek their assistance in resolving any issues or difficulties that may occur with the LegalShield member.',
  'I will let the Provider Firm know if my schedule is full and I am unable to accept referrals for a while.',
  'I will provide the Provider Firm with my updated declaration sheet each year as soon as I receive it from my insurance carrier.',
  'I am not a LegalShield marketing associate and will not become one.',
];

const eligibilityList = [
  'Before accepting a referred Client, Referral Attorney will conduct a review of his or her records to determine whether a conflict of interest is present.',
  'Have a minimum of two (2) years’ experience in the practice of law.',
  'No public discipline by Disciplinary Board of the Supreme Court of your state.',
  'Maintain legal malpractice insurance with a minimum coverage of $100,000 per occurrence.',
  'Referral Attorney shall provide legal services to Clients at a discount of twenty-five percent (25%) from the Referral Attorney’s standard hourly rate.',
];

const TermsTextRenderer = () => (
  <div className="rnq-terms">
    <Heading as="T39" text="Referral Lawyer Service Commitment" classNames={['mb-3']} />
    <ul>
      {commitmentList.map((item, i) => (
        <li key={i}>{item}</li>
      ))}
    </ul>
    <Heading as="T16" text="Eligibility" />
    <ol>
      {eligibilityList.map((item, i) => (
        <li key={i}>{item}</li>
      ))}
    </ol>
  </div>
);

export default TermsTextRenderer;
